<div
  class="popUp-bg"
  id="popUp-bg"
  role="img"
  aria-label="background-image"
  [ngClass]="{ display: mostrarPopUp }"
></div>
<div
  class="popUp flex-col"
  id="popUp"
  [ngClass]="{
    display: mostrarPopUp,
    'bg-color-white': error || resposta,
    shadow: error || resposta
  }"
>
  <button
    aria-label="fechar"
    type="button"
    class="btn-close btn"
    id="close-btn"
    (click)="fechaPopUp()"
    *ngIf="error || resposta"
  >
    <svg
      width="29"
      height="30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="close-icon"
    >
      <path
        d="M3 3L26 27"
        stroke="black"
        stroke-width="6"
        stroke-linecap="round"
      />
      <path
        d="M26 3L3 27"
        stroke="black"
        stroke-width="6"
        stroke-linecap="round"
      />
    </svg>
  </button>
  <ng-container *ngIf="!error && !resposta">
    <svg
      width="216"
      height="216"
      viewBox="0 0 216 216"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="carregando"
    >
      <circle
        cx="108"
        cy="108"
        r="100"
        stroke="#08A591"
        stroke-width="16"
        id="circle"
        #circle
      />
    </svg>
  </ng-container>
  <ng-container *ngIf="!error && resposta">
    <svg
      width="220"
      height="195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      #sucesso
      id="sucesso"
    >
      <title>Sucesso!</title>
      <path d="M7 107L103 178.5L210 6" stroke="#26B09F" stroke-width="17" />
    </svg>

    <h2 class="popUp-title">Obrigado por sua colaboração.</h2>
    <p class="popUp-paragraph">
      <strong>Código da sua sugestão:</strong> {{ resposta && resposta.codigo }}
    </p>
    <p class="popUp-paragraph">{{ textoInformativo }}</p>
    <p class="popUp-paragraph flex-row">
      <img src="assets/common/gmail.svg" alt="icone gmail" class="img" />
      <span class="info"
        >Uma cópia da sua sugestão será encaminhada para seu endereço de
        e-mail.</span
      >
    </p>
  </ng-container>

  <ng-container *ngIf="error">
    <svg
      width="181"
      height="181"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="falha"
    >
      <path d="M8 8L173 173" stroke="#EB5757" stroke-width="22" />
      <path d="M173 8L8 173" stroke="#EB5757" stroke-width="22" />
    </svg>
    <h2 class="popUp-title">
      Desculpe, ocorreu um erro no envio da sua sugestão.
    </h2>
    <span class="flex-col btn-container">
      <button
        type="button"
        class="btn rounded-pill btn-primary btn-md"
        (click)="tentarNovamente()"
      >
        Tentar novamente
      </button>
      <button
        type="button"
        class="btn rounded-pill btn-red btn-md"
        (click)="cancelar()"
      >
        cancelar
      </button>
    </span>
  </ng-container>
</div>
